import {Box} from '@mantine/core';
import React from 'react';

import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepRawData} from 'pipelines/PipelineTypes';
import ScratchPlatePaneContent from 'pipelines/plates/ScratchPlatePaneContent';

/**
 * Popover contents for a scratch plate: a lightweight summary (name and grid
 * dimensions), matching what the full plate view surfaces today.
 */
export default function PlatePopoverContents({
  rawData,
}: {
  rawData: PipelineStepRawData<PipelineStepDataKind.PLATE>;
}): JSX.Element {
  return (
    <Box p="xs">
      <ScratchPlatePaneContent scratchPlate={rawData} />
    </Box>
  );
}
